<template>
    <div>
        <v-row no-gutters align="center">
          <v-col cols="6">
            <modal-cadu :close="close" :width="736" v-model="show">
                <div slot="all" class="py-10 px-10">
                    <div slot="header">
                        <div class="font-secundaria headline font-weight-normal border-header" style="color: #60656C">
                            Excluir
                        </div>
                    </div>
                    <div slot="body" class="my-3">
                        <v-row>
                            <v-col cols="12" class="font-secundaria text-center my-4" style="font-size: 20px">
                                {{text}}
                            </v-col>
                        </v-row>
                    </div>
                    <div slot="footer">
                        <div v-if="!$vuetify.breakpoint.xs">
                            <v-row
                                aligh="end"
                                justify="end"
                                no-gutters
                            >
                                <v-col class="mr-6" cols="12" sm="auto">
                                    <button-cadu
                                        @click="$emit('close')"
                                        text="CANCELAR"
                                        :outline="true"
                                        backColor="#00995D"
                                        :disabled="false"
                                    />
                                </v-col>
                                <v-col cols="12" sm="auto">
                                    <button-cadu
                                        text="EXCLUIR"
                                        @click="$emit('confirmDelete')"
                                        :backColor="$vuetify.theme.themes.light.warningUtil1"
                                    />
                                </v-col>
                            </v-row>
                        </div>
                        <div v-else>
                            <v-row>
                                <v-col cols="12">
                                    <button-cadu
                                        @click="$emit('close')"
                                        text="CANCELAR"
                                        :outline="true"
                                        backColor="#00995D"
                                        :disabled="false"
                                        block
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <button-cadu
                                        text="EXCLUIR"
                                        @click="$emit('confirmDelete')"
                                        :backColor="$vuetify.theme.themes.light.warningUtil1"
                                        block
                                    />
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </div>
            </modal-cadu>
          </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
  props: {
    showDelete: {
      type: Boolean,
      required: true
    },
    text: {
      type: String,
      required: false,
      default: 'Tem certeza que deseja excluir esse endereço?'
    }
  },
  data () {
    return {
      close: true,
      show: this.showDelete
    }
  },
  watch: {
    show () {
      if (!this.show) {
        this.$emit('close')
      }
    },
    showDelete () {
      this.show = this.showDelete
    }
  }
}
</script>

<style scoped>
    .border-header{
        border-bottom: 1px solid #CCCCCC;
        padding-bottom: 17px;
    }
</style>
